// Duits (de-DE), kaartApp: zelfde vorm als kaartApp.nl.ts (golf 3-integratie). Die Schritte für
// Google, Outlook und das iPhone nennen die Schaltflächen so, wie diese Apps sie auf Deutsch zeigen.
export const appPlacesDe = {
    placeholder: 'Tippe einen Ort, zum Beispiel Schwimmbad De Vliet',
    hintSearch: 'Tippe mindestens 3 Buchstaben: Du bekommst Vorschläge aus Google Maps.',
    searching: 'Suche...',
    suggestions: 'Vorschläge',
    noResults: 'Nichts gefunden. Du kannst den Ort auch einfach tippen.',
    attribution: 'Vorschläge von Google Maps',
    chosen: 'Gewählter Ort',
    change: 'Anderer Ort',
    remove: 'Ort entfernen',
    typedOnly: 'Nur Text (kein Ort auf der Karte)',
    notConfigured: 'Die Suche über Google Maps ist auf diesem Server noch nicht aktiv. Tippe den Ort einfach.',
    unavailable: 'Google Maps antwortet gerade nicht. Tippe den Ort einfach oder versuche es gleich noch einmal.',
    tooMany: 'Gerade zu viele Suchanfragen. Versuche es in {minutes} Minuten noch einmal.',
    saveFailed: 'Der Ort wurde nicht gespeichert (der Termin schon). Versuche es gleich noch einmal.',
    travelTitle: 'Fahrzeit',
    travelAuto: '{minutes} Min. {mode}',
    travelAutoHint: 'Berechnet ab eurem Wohnort. Wählst du unten selbst eine Fahrzeit, zählt diese.',
    travelPending: 'Wird beim Speichern berechnet.',
    travelStatus: {
        no_origin: 'Wähle zuerst den Ort eurer Familie, dann berechnet die App die Fahrzeit.',
        no_route: 'Google Maps kennt keine Route zu diesem Ort.',
        not_configured: 'Die Fahrzeitberechnung ist auf diesem Server noch nicht aktiv.',
        unavailable: 'Die Fahrzeit ließ sich gerade nicht berechnen. Beim nächsten Speichern versuchen wir es noch einmal.',
        module_off: 'Fahrzeit ist ausgeschaltet (Einstellungen · Module).',
    },
    modeTitle: 'Wie kommt ihr hin?',
    modeUsual: 'Wie immer',
    modes: { drive: 'Auto', bicycle: 'Fahrrad', walk: 'Zu Fuß' },
    modeWith: { drive: 'mit dem Auto', bicycle: 'mit dem Fahrrad', walk: 'zu Fuß' },
    autoOption: 'Automatisch ({minutes} Min.)',
    // fix/afspraakformulier: schakelaar bij "Waar" (onthouden op dit apparaat, per gebruiker).
    google: 'Mit Google Maps suchen',
    googleOn: 'An: Vorschläge über unseren Server (Google Maps).',
    googleOff: 'Aus: Du tippst den Ort selbst. Nichts geht an Google.',
    moduleOff: 'Orte suchen ist aus (Einstellungen · Module). Tippe den Ort einfach ein.',
};
export const appTravelDe = {
    title: 'Fahrzeit und Orte',
    intro: 'Wähle bei „Wo“ einen Ort aus den Vorschlägen, dann berechnet die App, wie lange ihr unterwegs seid. Das Tablet sagt euch dann rechtzeitig, dass ihr losmüsst.',
    modeTitle: 'So sind wir meistens unterwegs',
    modeHint: 'Pro Termin kannst du etwas anderes wählen.',
    saved: 'Gespeichert',
    originMissing: 'Euer Ort fehlt noch. Ohne Startpunkt keine Fahrzeit.',
    originLink: 'Ort wählen',
    googleOff: 'Google Maps ist auf diesem Server noch nicht aktiv: Vorschläge und Fahrzeit funktionieren dann nicht. Tippen bei „Wo“ funktioniert immer.',
    privacyTitle: 'Was geht an Google?',
    privacyBody: 'Nur was du bei „Wo“ tippst, ein grober Ort rund um euren Wohnort (etwa 5 km) und für die Fahrzeit der Startpunkt auf etwa einen Kilometer genau. Nie Namen, E-Mail-Adressen oder wer mitkommt. Google rechnet für uns; das Tablet und dein Browser sprechen nie mit Google.',
    settingsBody: 'Auto, Fahrrad oder zu Fuß; was an Google geht',
};
export const appFeedsDe = {
    title: 'Kalender verbinden',
    settingsBody: 'Eure Termine auch in Google, Outlook oder auf dem iPhone',
    intro: 'Bring eure Termine auch in Google Kalender, Outlook oder auf dein iPhone. Geplant wird weiter auf dem Board: Was du dort änderst, kommt nicht zurück.',
    oneWay: 'Nur in eine Richtung',
    inbound: 'Andersherum, einen Kalender von Schule oder Sport hereinholen? Das machst du bei Kalender.',
    inboundLink: 'Zu den Kalendern',
    forWho: 'Für wen',
    lastFetchedNever: 'noch nie',
    settingsLabel: 'Einstellungen dieses Links',
    newTitle: 'Neuer Link',
    whose: 'Welche Termine?',
    whole: 'Die ganze Familie',
    memberOnly: 'Nur {name}',
    busyOnly: 'Nur „Beschäftigt“ zeigen',
    busyOnlyHint: 'Andere sehen, dass etwas ist, aber nicht was. Praktisch für einen Arbeitskalender.',
    faith: 'Auch Termine zu unserem Glauben (wie Beten oder Moscheeunterricht)',
    faithHint: 'Standardmäßig aus: Google, Microsoft oder Apple lesen dann mit.',
    create: 'Link erstellen',
    creating: 'Einen Moment...',
    created: 'Dein Link ist fertig',
    copy: 'Link kopieren',
    copied: 'Kopiert',
    copyFailed: 'Kopieren hat nicht geklappt. Markiere den Link und kopiere ihn selbst.',
    openApple: 'In Kalender öffnen (iPhone, Mac)',
    linkOnce: 'Füge den Link jetzt in deine Kalender-App ein. Wir speichern ihn nicht lesbar: Später erstellst du einfach einen neuen.',
    linkLabel: 'Dein Link',
    listTitle: 'Eure Links',
    empty: 'Noch keine Links. Erstelle oben einen.',
    forWhole: 'Ganze Familie',
    forMember: '{name}',
    badgeBusy: 'Nur beschäftigt',
    badgeFaith: 'Mit Glauben',
    lastFetched: 'Zuletzt abgerufen: {when}',
    neverFetched: 'Noch von keiner Kalender-App abgerufen',
    hiddenLink: 'Den Link selbst siehst du nur beim Erstellen.',
    renew: 'Neuer Link',
    renewTitle: 'Neuen Link erstellen?',
    renewBody: 'Der alte Link funktioniert danach nicht mehr. Füge den neuen Link erneut in deine Kalender-App ein.',
    renewConfirm: 'Neuen Link erstellen',
    revoke: 'Widerrufen',
    revokeTitle: 'Link widerrufen?',
    revokeBody: 'Dieser Link funktioniert dann sofort nicht mehr. Die Termine verschwinden bei der nächsten Aktualisierung aus dem anderen Kalender.',
    revokeConfirm: 'Widerrufen',
    revoked: 'Link widerrufen',
    cancel: 'Abbrechen',
    tooMany: 'Höchstens 20 Links pro Familie. Widerrufe zuerst einen alten Link.',
    howTitle: 'So fügst du ihn hinzu',
    google: {
        title: 'Google Kalender',
        steps: [
            'Öffne Google Kalender auf einem Computer (calendar.google.com).',
            'Klicke links bei „Weitere Kalender“ auf das Pluszeichen.',
            'Wähle „Per URL“.',
            'Füge den Link ein und klicke auf „Kalender hinzufügen“.',
        ],
    },
    outlook: {
        title: 'Outlook und Microsoft 365',
        steps: [
            'Öffne Outlook im Web (outlook.office.com oder outlook.live.com).',
            'Geh zu Kalender und wähle „Kalender hinzufügen“.',
            'Wähle „Aus dem Internet abonnieren“.',
            'Füge den Link ein, gib dem Kalender einen Namen und klicke auf „Importieren“.',
        ],
    },
    apple: {
        title: 'iPhone und iCloud',
        steps: [
            'Öffne die Einstellungen auf deinem iPhone.',
            'Tippe auf Apps, dann Kalender, dann Kalenderaccounts, dann „Account hinzufügen“. (Auf einem älteren iPhone: Kalender, dann Accounts.)',
            'Tippe auf „Andere“ und dann auf „Kalenderabo hinzufügen“.',
            'Füge den Link ein und tippe auf „Weiter“ und „Sichern“.',
        ],
    },
    refreshNote: 'Ehrlich gesagt: Google Kalender ruft so einen Link nur alle paar Stunden ab, manchmal noch seltener. Outlook und das iPhone tun es öfter. Eine Änderung steht also nicht sofort überall; auf dem Board schon.',
    privacyNote: 'Private Termine gehen nie mit. Wer den Link hat, kann die Termine lesen: Gib ihn nicht weiter und widerrufe ihn, wenn er irgendwo herumliegt.',
    icsBusy: 'Beschäftigt',
    /** Een bijzondere dag van meer dagen in de .ics. */
    icsDayOf: '{title} (Tag {index} von {count})',
};
//# sourceMappingURL=kaartApp.de.js.map